//amgular
import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//rxjs
import { Observable } from 'rxjs';

//local
import { Dictionary } from '../_types/dictionary';
import { ReferenceType } from '../_enums/referenceType';
import { AppConfig } from '../app-config';
import { Right } from '../_interfaces/right';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient,
    private applicationConfig: AppConfig
  ) { }

  getRights(): Observable<Right[]> {    
    return this.http.get<Right[]>(`${this.applicationConfig.applicationUri}/v2/user/permissions`);
  }

  getUserCategoryAccess(): Observable<AAAAccessResponse> {
    return this.http.get<AAAAccessResponse>(`${this.applicationConfig.applicationUri}/v2/user/categories`);
  }
}

export const LIBRARY: string = 'Library';
export const CATALOG: string = 'Catalog';
export const SPACEBOT: string = 'SpaceBot';
export const VIEW: string = 'View';
export const ADD: string = 'Add';
export const EDIT: string = 'Edit';
export const DELETE: string = 'Delete';
export const CONFIGURE: string = 'Configure';

export class AAARights {
  public rights: Dictionary<string, Dictionary<string, WritableSignal<boolean>>>;
  constructor() {
    this.rights = {};
    this.rights[CATALOG] = {};
    this.rights[CATALOG][VIEW] = signal(false);
    this.rights[CATALOG][CONFIGURE] = signal(false);
    this.rights[LIBRARY] = {};
    this.rights[LIBRARY][VIEW] = signal(false);
    this.rights[LIBRARY][ADD] = signal(false);
    this.rights[LIBRARY][EDIT] = signal(false);
    this.rights[LIBRARY][DELETE] = signal(false);
    this.rights[LIBRARY][CONFIGURE] = signal(false);
    this.rights[SPACEBOT] = {}; 
    this.rights[SPACEBOT][VIEW] = signal(false);
  }

  public scan(aaa: AAAAccessResponse): void {
    aaa.companyAccessItems.forEach((ai) => {
      this.scanRightGroup(ai.rightGroups);
    });
    aaa.programAccessItems.forEach((ai) => {
      this.scanRightGroup(ai.rightGroups);
    });
    aaa.projectAccessItems.forEach((ai) => {
      this.scanRightGroup(ai.rightGroups);
    });
  }

  private scanRightGroup(rgrs: AAARightGroupRights[]) {
    rgrs.forEach((rgr) => {
      // Suppress old-web-spacebot for now
      if (rgr.rightGroup.name != SPACEBOT && this.rights[rgr.rightGroup.name] !== undefined) {
        rgr.rights.forEach((r) => {
          if (this.rights[rgr.rightGroup.name][r.name] !== undefined) {
            this.rights[rgr.rightGroup.name][r.name].set(true);
          }
        });
      }
    });
  }
}

export class AAAAccessResponse {
  companyAccessItems: CompanyAccessItem[];
  programAccessItems: ProgramAccessItem[];
  projectAccessItems: ProjectAccessItem[];
}

class CompanyAccessItem {
  company: AAASecurable;
  categories: AAACategory[];
  rightGroups: AAARightGroupRights[];
  roles: AAARole[];
}

class ProgramAccessItem {
  program: AAASecurable;
  categories: AAACategory[];
  rightGroups: AAARightGroupRights[];
  roles: AAARole[];
}

class ProjectAccessItem {
  project: AAASecurable;
  categories: AAACategory[];
  rightGroups: AAARightGroupRights[];
  roles: AAARole[];
}

class AAASecurable {
  id: string;
  sqlId: string;
  name: string;
  description: string | null;
}

class AAACategory {
  id: string;
  name: string;
  referenceType: ReferenceType;
  securityInformation: AAARightGroupRights;
}


class AAARightGroup {
  id: string;
  name: string;
}

class AAARight {
  id: string;
  name: string;
  uri: string | null;
}

class AAARightGroupRights {
  rightGroup: AAARightGroup;
  rights: AAARight[];
}
class AAARole {
  id: string;
  name: string;
  description: string;
}